import React, { useEffect, useMemo, useState } from "react";
import Card from "../../../components/common/Card";
import Paper from "@mui/material/Paper";
// import { DataGrid } from "@mui/x-data-grid";
import DateRangePickerComponent from "../../../components/common/DateRangePickerComponent";
import "./ViewFuelPurchase.css";
// import DataTable from "../../components/common/ReusableTable/Table";
import ReactMuiTable from "../../../components/common/ReusableTable/ReactTable";
import ColumnFilter from "../../../components/common/ColumnFilter";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  getShiftDetails1,
  getSiteDetails,
  vehicleTypes,
  viewTripDetails,
} from "../../../services/vehicleService";
import { useFormik } from "formik";
// import { withErrorHandler } from "../../utils/tryCatchHandler";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../redux/features/authSliceandSidebar";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import ConfimationModal from "../../../components/modals/ConfirmationModal";
import { getFuelPurchase } from "../../../services/FuelService";

const TrackFuelPUrchase = () => {
  const [activeTab, setActiveTab] = useState("permanent");
  const [searchQuery, setSearchQuery] = useState("");
  // const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [selectedRadio, setSelectedRadio] = useState("active");

  const [detailObj, setDetailObj] = useState(null);
  let today = new Date();
  let yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const [previousDate, setPreviousDate] = useState(new Date());
  const [dateRange, setDateRange] = useState([
    {
      startDate: yesterday,
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [formData, setFormData] = useState({
    employeeType: "permanent",
    department: "",
    employeeId: "",
    fullName: "",
    contact: "",
    email: "",
  });

  const [key, setKey] = useState(Math.random());
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [activeId, setActiveId] = useState(0);
  const isLogin = useSelector((x) => x.authSliceandSidebar.isLogin);
  const dispatch = useDispatch();
  const [tripData, setTripData] = useState([]);

  const [vehicleList, setVehicleList] = useState([]);
  const [sitesList, setSitesLsit] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [showModal1, setShowModal1] = useState(false);

  const rawColumns = [
    { Header: "FuelId", accessor: "id" },
    // { Header: "Name", accessor: "vehicleName" },
    // { Header: "Vehicle No.", accessor: "vehicleNumber" },
    // {
    //   Header: "Trip Date",
    //   accessor: "tripDate",
    //   Cell: (cell) => {
    //     return cell?.row?.original?.tripDate
    //       ? moment(cell.row.original.tripDate).format("DD-MM-YYYY")
    //       : "";
    //   },
    // },
    { Header: "Vendor Name", accessor: "vendorName" },
    { Header: "Fuel Type", accessor: "fuelType" },
    { Header: "Fuel Rate", accessor: "rate" },
    { Header: "Quantity", accessor: "quantity" },
    { Header: "Created By", accessor: "createdBy" },
    // { Header: "Created At", accessor: "createdAt" },

    {
      Header: "Created At",
      accessor: "createdAt",
      Cell: (cell) => {
        return cell?.row?.original?.createdAt
          ? moment(cell.row.original.createdAt).format("DD-MM-YYYY")
          : "";
      },
    },

    // { Header: "Rehandling Trip", accessor: "tripSoft" },
    // { Header: "Trip Count", accessor: "tripsCount" },
    {
      Header: "View",
      Footer: "User-Action",
      accessor: "action",
      Cell: (cell) => {
        return (
          <>
            <IconButton
              title="View Detail"
              style={{ marginLeft: "19%" }}
              onClick={() => {
                viewDetail(cell);
              }}
            >
              <VisibilityIcon style={{ color: "blue", fontSize: "19px" }} />
            </IconButton>
          </>
        );
      },
      disableFilters: true,
    },
  ];

  const columns = React.useMemo(() => {
    return rawColumns;
  }, []);
  const paginatedData = React.useMemo(() => {
    const start = pageIndex * pageSize;
    return tripData?.slice(start, start + pageSize);
  }, [pageIndex, pageSize, tripData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const viewDetail = (cell) => {
    // console.log(cell.row.original);
    setDetailObj(cell.row.original);
    setShowModal1(true);
  };

  function toNormalCase(key) {
    return key
      ?.replace(/([A-Z])/g, " $1")
      ?.replace(/^./, (str) => str.toUpperCase()) // capitalize first letter
      .trim(); // remove any leading space
  }
  useEffect(() => {
    if (isLogin) {
      dispatch(setLoader(true));
      //   getVehiclees();
      //   getSites();
      //   getShiftDetails();
      getFuelPurchaseDetails();
    }
  }, [isLogin]);

  const getFuelPurchaseDetails = async () => {
    await getFuelPurchase().then((res) => {
      dispatch(setLoader(false));
      if (res && res.data?.statusDescription?.statusCode == 200) {
        // console.log(res?.data);
        setKey(Math.random());
        setTripData(res.data.fuelPurchaseDetails);
        dispatch(setLoader(false));
      }
    });
  };

  //   const getSites = async () => {
  //     setSitesLsit([]);
  //     withErrorHandler(
  //       await getSiteDetails().then((res) => {
  //         if (res && res.data.statusDescription?.statusCode == 200) {
  //           // console.log(res.data);
  //           setSitesLsit(res.data.siteDetails);
  //           formik.setFieldValue(
  //             "tripDate",
  //             moment(new Date()).format("YYYY-MM-DD")
  //           );
  //           formik.setFieldValue("siteIdState", res.data.siteDetails[0]);
  //           formik.setFieldValue("siteId", res.data.siteDetails[0].siteId);
  //         } else if (res && res.data.statusDescription?.statusCode == 401) {
  //           dispatch(setLoader(false));
  //         }
  //       })
  //     );
  //   };

  //   const getShiftDetails = async () => {
  //     setShiftList([]);
  //     withErrorHandler(
  //       await getShiftDetails1().then((res) => {
  //         if (res && res.data.statusDescription?.statusCode == 200) {
  //           setShiftList(res.data.shiftDetails);
  //           formik.setFieldValue("shiftId", res.data.shiftDetails[0].shiftId);

  //           formik.setFieldValue("shiftName", res.data.shiftDetails[0].name);
  //           dispatch(setLoader(false));
  //           // setSelectedRadio(res.data.shiftDetails[0].shiftId);
  //         } else {
  //         }
  //       })
  //     );
  //   };

  //   const getVehiclees = async () => {
  //     setVehicleList([]);
  //     withErrorHandler(
  //       await vehicleTypes().then((res) => {
  //         if (res && res.data.statusDescription?.statusCode == 200) {
  //           setVehicleList(res.data.data);
  //           setActiveTab(res.data.data[0].name);
  //           setActiveId(res.data.data[0].vehicleTypeId);

  //           formik.setFieldValue("vehicleTypeId", res.data.data[0].vehicleTypeId);
  //           formik.setFieldValue("vehicleName", res.data.data[0].name);
  //           // setSelectedRadio(res.data.shiftDetails[0].shiftId);
  //         } else {
  //         }
  //       })
  //     );
  //   };

  const formik = useFormik({
    initialValues: {
      siteId: null,
      shiftId: null,
      tripDate: null,
      siteIdState: null,
      tripDateState: new Date(),
      vehicleTypeId: null,
      vehicleName: "",
      shiftName: "",
      startDate: null,
      endDate: null,
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {
      dispatch(setLoader(true));
      // console.log(values);
      setTripData([]);
      let formdata = { ...values };
      delete formdata["siteIdState"];

      delete formdata["tripDate"];
      formdata["startDate"] = dateRange[0]?.startDate;
      formdata["endDate"] = dateRange[0]?.endDate;
      await viewTripDetails(formdata).then((res) => {
        dispatch(setLoader(false));
        if (res && res?.data?.statusDescription?.statusCode == 200) {
          setTripData(res.data.tripdetaillog1);
        }
      });
    },
  });
  useEffect(() => {
    if (
      formik.values.shiftId &&
      formik.values.siteId &&
      dateRange &&
      formik.values.vehicleTypeId
    ) {
      document.getElementById("go_for_hit")?.click();
    }
  }, [formik.values.vehicleTypeId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Form submitted:", formData);
  };

  const getHeader = (x) => {
    return <h4>{x?.toString()}</h4>;
  };

  return (
    <div className="staff-management">
      <Card title={`View fuel stock`}>
        <form onSubmit={handleSubmit}>
          {/* <div className="container-fluid main_container"> */}
          <div className="form-row group_div">
            <Paper style={{ width: "100%" }}>
              {tripData?.length > 0 ? (
                <ReactMuiTable
                  columns={columns}
                  data={paginatedData}
                  pageIndex={pageIndex}
                  key={key}
                  pageSize={pageSize}
                  totalCount={tripData.length}
                  onPageChange={(newPage) => {
                    setKey(Math.random());
                    setPageIndex(newPage);
                  }}
                  onPageSizeChange={(newSize) => {
                    setKey(Math.random());
                    setPageSize(newSize);
                    setPageIndex(0);
                  }}
                />
              ) : (
                <div className="d-block text-center px-5  py-5">
                  <h4>No record found</h4>
                </div>
              )}
            </Paper>
          </div>
        </form>

        <ConfimationModal
          show={showModal1}
          onHide={() => setShowModal1(false)}
          size="lg"
          onSubmit={() => {
            setShowModal1(false);
          }}
          title={
            "View Details" +
            " > " +
            detailObj?.siteName +
            " > " +
            detailObj?.vehicleName +
            " > " +
            detailObj?.vehicleNumber
          }
          hideSubmit={true}
        >
          <div className="container">
            <div className="row">
              {detailObj &&
                Object.keys(detailObj).map((x) => {
                  return (
                    <>
                      {detailObj[x] && !x.includes("Id") ? (
                        <div className="col-md-3 mt-2">
                          {/* {toNormalCase(x)} */}
                          <TextField
                            value={
                              x.toLowerCase().includes("date") ||
                              x.toLowerCase().includes("createdat")
                                ? moment(detailObj[x]).format("DD-MM-YYYY")
                                : detailObj[x]
                            }
                            label={x ? toNormalCase(x) : ""}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
            </div>
          </div>
        </ConfimationModal>
      </Card>
    </div>
  );
};

export default TrackFuelPUrchase;
